var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20998 8.2106V13.9808M11.0948 11.0957L8.20998 8.2106L5.32514 11.0957M2.44055 9.58048C1.90472 9.03298 1.5005 8.3707 1.25851 7.64383C1.01652 6.91695 0.943108 6.14452 1.04383 5.38507C1.14455 4.62561 1.41676 3.89903 1.83985 3.26037C2.26294 2.62171 2.82581 2.08771 3.48582 1.69883C4.14584 1.30995 4.88569 1.07637 5.64933 1.0158C6.41298 0.955236 7.18039 1.06926 7.89345 1.34924C8.6065 1.62921 9.2465 2.0678 9.76496 2.63178C10.2834 3.19576 10.6668 3.87035 10.8859 4.60443H12.1769C12.8732 4.60435 13.5511 4.82826 14.1104 5.24308C14.6698 5.65789 15.0808 6.24162 15.283 6.90803C15.4851 7.57445 15.4675 8.2882 15.2329 8.94387C14.9982 9.59954 14.5589 10.1623 13.9799 10.5492",
    stroke: "#2B3688",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon12);
export default __webpack_public_path__ + "static/media/uploadIcon12.e8925351ebd1959bfe21f4ac9715314a.svg";
export { ForwardRef as ReactComponent };